import IdleDetect from './IdleDetect.container'

export default IdleDetect
